import React, { useState, useCallback, useEffect } from 'react'

interface DocumentWithFullscreen extends Document {
  webkitFullscreenElement?: Element | null
  mozFullScreenElement?: Element | null
}

const fullscreenElement = (): Element | null => {
  if ('undefined' === typeof document) {
    return null
  }
  if ('fullscreenElement' in document && document.fullscreenElement) {
    return document.fullscreenElement
  }
  const doc = document as DocumentWithFullscreen
  if ('webkitFullscreenElement' in doc && doc.webkitFullscreenElement) {
    return doc.webkitFullscreenElement
  }
  if ('mozFullScreenElement' in doc && doc.mozFullScreenElement) {
    return doc.mozFullScreenElement
  }
  return null
}
/* eslint-enable compat/compat */

const useFullScreen = ({
  componentRef,
  blockWidth
}: {
  componentRef: React.MutableRefObject<HTMLElement>
  blockWidth: number
}): { fullscreenBlockWidth: number; componentFullScreen: () => void } => {
  const [fullscreenBlockWidth, setFullscreenBlockWidth] = useState(blockWidth)

  /**
   * Switch between full screen/normal mode
   */
  const componentFullScreen = useCallback(() => {
    if (!fullscreenElement()) {
      componentRef.current.requestFullscreen().then(
        () => {
          setFullscreenBlockWidth(window.innerWidth)
          // setFullScreen(true)
        },
        () => {
          setFullscreenBlockWidth(window.innerWidth)
        }
      )
    } else {
      void document.exitFullscreen()
    }
  }, [componentRef])

  /**
   * Controls over full screen mode
   */
  useEffect(() => {
    const change = () => {
      if (!fullscreenElement()) {
        setFullscreenBlockWidth(blockWidth)
        // setFullScreen(false)
      }
    }
    change()
    // document.addEventListener('fullscreenchange', change)
    // return () => document.removeEventListener('fullscreenchange', change)
  }, [blockWidth])

  return { fullscreenBlockWidth, componentFullScreen }
}

export default useFullScreen
